










import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DebugData extends Vue {
  @Prop({ required: true })
  private selected!: string | string[];
  @Prop({ required: true })
  private frameworks!: Set<string>;
}
